<template>
  <div id="home">

    <intro />

    <articles>
    </articles>

    <about />

    <articles2>    
    </articles2>

    <about2 />

  </div>
</template>

<script>
  export default {
    name: 'Home',

    components: {
      About: () => import('@/components/home/About'),
      About2: () => import('@/components/home/About2'),
      Intro: () => import('@/components/home/Intro'),
      Articles: () => import('@/components/home/Articles'),
      Articles2: () => import('@/components/home/Articles2'),
      Banner: () => import('@/components/home/Banner'),
    },
  }
</script>
